export default {
  en: 'English',
};



// WEBPACK FOOTER //
// ./src/config/locales/fr/language-switcher.js